import $axios from '~/plugins/axios';

import { Api, CampaignAdditionalMaterial, PaginatorResult } from '~/api';
import { buildModule, createPaginationModule } from '../utils';
import { Dict, createDict } from '~/helpers';
import { GetCampaignAdditionalMaterialParams } from '../../api/params';

const api = $axios as Api;

export default buildModule()
	.withSubmodules({
		pagination: createPaginationModule({
			pageQueryKey: 'campaignAdditionalMaterialsPage',
			pageSizeQueryKey: 'campaignAdditionalMaterialsPerPage',
			itemCountGetter: 'campaignAdditionalMaterials/list/totalCount',
		}),
	})
	.withState({
		storedCampaignAdditionalMaterials: {} as Dict<CampaignAdditionalMaterial>,
		campaignAdditionalMaterials: [] as CampaignAdditionalMaterial[],
		loading: false,
		paginator: null as PaginatorResult | null,
	})
	.withGetters({
		byId: state => (campaignAdditionalMaterialId: number) => (
			state.storedCampaignAdditionalMaterials[campaignAdditionalMaterialId] ?? null
		),
		page: state => state.campaignAdditionalMaterials,
		loading: state => state.loading,
		totalCount: state => state.paginator?.totalCount ?? 0,
	})
	.withMutations({
		SET_STORED_CAMPAIGN_ADDITIONAL_MATERIALS (state, campaigns: CampaignAdditionalMaterial[]) {
			state.storedCampaignAdditionalMaterials = {
				...state.storedCampaignAdditionalMaterials,
				...createDict(campaigns, (campaign) => campaign.id),
			};
		},
		SET_CAMPAIGN_ADDITIONAL_MATERIALS (state, campaignAdditionalMaterialIds: number[]) {
			state.campaignAdditionalMaterials = campaignAdditionalMaterialIds.map(id => state.storedCampaignAdditionalMaterials[id]);
		},
		SET_LOADING (state, loading: boolean) {
			state.loading = loading;
		},
		SET_PAGINATOR (state, paginator: PaginatorResult) {
			state.paginator = paginator;
		},
	})
	.withActions({
		async get ({ commit }, params: GetCampaignAdditionalMaterialParams = {}) {
			commit('SET_LOADING', true);
			const { data } = await api.get('/campaign-additional-material', { params });
			commit('SET_LOADING', false);

			const campaignAdditionalMaterials = data.payload;
			const campaignAdditionalMaterialIds = campaignAdditionalMaterials.map(campaignAdditionalMaterial => campaignAdditionalMaterial.id);

			commit('SET_STORED_CAMPAIGN_ADDITIONAL_MATERIALS', campaignAdditionalMaterials);
			commit('SET_CAMPAIGN_ADDITIONAL_MATERIALS', campaignAdditionalMaterialIds);
			commit('SET_PAGINATOR', data.paginator);
		},
	});
